import React, { useEffect, useState } from 'react';
import { getMonthlySummary, getWeeklySummary } from '../services/timesheetService';

const MonthlySummary = ({ employeeId }) => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [summary, setSummary] = useState(null);
  const [weekly, setWeekly] = useState(null);
  const [error, setError] = useState('');

  const load = async () => {
    try {
      setError('');
      const res = await getMonthlySummary(employeeId, year, month);
      setSummary(res.data);
      const weeklyRes = await getWeeklySummary(employeeId, new Date().toISOString().split('T')[0]);
      setWeekly(weeklyRes.data);
    } catch (e) {
      setError('Erreur lors du chargement du résumé mensuel');
    }
  };

  useEffect(() => {
    if (employeeId) {
      load();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeId, year, month]);

  return (
    <div className="card">
      <h3>Résumé mensuel</h3>
      <div className="form-row">
        <input type="number" value={year} onChange={(e) => setYear(e.target.value)} min="2020" max="2100" />
        <input type="number" value={month} onChange={(e) => setMonth(e.target.value)} min="1" max="12" />
        <button className="btn btn-secondary" onClick={load}>Rafraîchir</button>
      </div>
      {error && <div className="error-banner">{error}</div>}
      {summary && (
        <ul>
          <li>Heures travaillées : {summary.totalWorkedHours}</li>
          <li>Heures supplémentaires : {summary.totalOvertimeHours}</li>
          <li>Absences : {summary.totalAbsentDays}</li>
          <li>Jours de congé : {summary.totalLeaveDays}</li>
          <li>Jours ouvrables : {summary.totalWorkingDays}</li>
        </ul>
      )}
      {weekly && (
        <>
          <h4>Résumé hebdomadaire (semaine courante)</h4>
          <ul>
            <li>Début semaine : {weekly.startOfWeek}</li>
            <li>Fin semaine : {weekly.endOfWeek}</li>
            <li>Heures travaillées semaine : {weekly.workedWeekHours}</li>
            <li>Heures sup semaine : {weekly.overtimeWeekHours}</li>
          </ul>
        </>
      )}
    </div>
  );
};

export default MonthlySummary;

